var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cms"
  }, [_c('div', {
    staticClass: "cms-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.cmsInfo.cmsTitile))]), _c('div', {
    staticClass: "cms-info"
  }, [_c('span', {
    staticClass: "gap"
  }, [_vm._v("本文发布于：" + _vm._s(_vm.cmsInfo.createTime))])])]), _c('a-divider'), _c('div', {
    staticClass: "article-content",
    domProps: {
      "innerHTML": _vm._s(_vm.cmsInfo.cmsContent)
    }
  }), _vm.cmsInfo.extraFile ? _c('div', {
    staticClass: "extra-file"
  }, [_c('p', [_vm._v("附件：")]), _vm._l(_vm.extraFilename, function (v, k, i) {
    return _c('p', {
      key: i
    }, [_c('span', [_vm._v(_vm._s(i + 1) + ". ")]), _c('a', {
      attrs: {
        "href": _vm.$store.getters.tenantInfo.qiniuDomain + '/' + k,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(v))])]);
  })], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };